import qs from 'querystring'

// Meant for a page level paginated search
export default class PaginationSearch {

  constructor( component, itemsKey, requestData ) {
    this.component = component
    this.itemsKey = itemsKey
    this.requestData = requestData
  }

  /**
   * Returns the items object used for pagination. This normally is a redux store object
   **/
  getItems( ) {
    return this.component && this.component.props && this.component.props[this.itemsKey]
  }

  /**
   * Returns the item to start the list from
   **/
  getStartFrom( props ) {
    const { location } = props
    const pSearch = location && location.search && qs.parse( location.search.slice( 1 ) )
    let start = pSearch && pSearch.start
    start = parseInt( start )
    if ( isNaN( start ) ) {
      start = 0
    } 
    return start
  }

  /**
   * Returns the search parameter to use
   **/
  getSearchFrom( props ) {
    const { location } = props
    const pSearch = location && location.search && qs.parse( location.search.slice( 1 ) )
    const search = pSearch && pSearch.search
    return search
  }

  getPerPage( ) {
    const items = this.getItems( )
    return ( items && items.perPage ) || 0
  }

  getTotal( ) {
    const items = this.getItems( )
    return ( items && items.total ) || 0
  }

  /**
   * Returns the current page based on start and items
   **/
  getPage( ) {
    const { start } = this.component.state
    const items = this.getItems( )
    if ( items && items.perPage ) {
      return 1 + ( start / items.perPage )
    }
    return 0
  }

  getPageItems() {
    const items = this.getItems()
    const { start } = this.component.state
    const perPage = this.getPerPage()
    const sub = items && items.items || []
    return sub.slice( start, start + perPage )
  }

  createUrl( start, search ) {
    const { location } = this.component.props
    const sstr = search ? `&search=${search}` : ''
    return `${location.pathname}?start=${start}${sstr}`
  }

  /**
   * Normally called from componentWillReceiveProps(), this will trigger a load
   * if the search or start index are different than current
   **/
  loadIfNeeded( nextProps ) {
    if ( this.getStartFrom( nextProps ) !== this.component.state.start ||
         this.getSearchFrom( nextProps ) != this.component.state.search ) {
      this.loadPage( nextProps )
    }
  }

  loadPage( props ) {
    const start = this.getStartFrom( props )
    const search = this.getSearchFrom( props )
    this.component.setState( { start, search } )
    const opts = { start }
    if ( search ) {
      opts.search = search
    }
    this.requestData( props, opts, this )
    // this.context.store.dispatch( DeviceActions.getDevices( params.systemId, opts ));
  }

  /**
   * Call this when the pagination view requests a change. This will
   * transition the router to a new url using the start and the string.
   * The page is 1 based
   **/
  onPageChange = ( page ) => {
    if ( page < 1 ) {
      page = 1
    }
    const items = this.getItems()
    const { history } = this.component.props
    const { search } = this.component.state
    if ( items == null ) {
      return
    }
    const sstr = search ? `&search=${search}` : ''
    const start = ( items.perPage || 100 ) * ( page - 1 )
    history.push( this.createUrl( start, search ) )

  }

  /**
   * Call this when the pagination view requests a change. This will
   * transition the router to a new url using the start and the string
   **/
  onSearchChange = ( search ) => {
    const { history } = this.component.props
    history.push( this.createUrl( 0, search ) )
  }

}
